export interface PasswordRequirement {
  label: string;
  validator: (password: string) => boolean;
  met: boolean;
}

export const PASSWORD_REQUIREMENTS = [
  {
    label: 'At least 6 characters',
    validator: (pwd: string) => pwd.length >= 6,
  },
  {
    label: 'At least 1 uppercase letter',
    validator: (pwd: string) => /[A-Z]/.test(pwd),
  },
  {
    label: 'At least 1 lowercase letter',
    validator: (pwd: string) => /[a-z]/.test(pwd),
  },
  {
    label: 'At least 1 number',
    validator: (pwd: string) => /[0-9]/.test(pwd),
  },
];

export const validatePassword = (password: string): PasswordRequirement[] => {
  return PASSWORD_REQUIREMENTS.map(req => ({
    ...req,
    met: req.validator(password),
  }));
};

export const isPasswordValid = (password: string): boolean => {
  return PASSWORD_REQUIREMENTS.every(req => req.validator(password));
};
